import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.333",
      d: "m13.084 11.243.002-.002a.73.73 0 0 1 1.037 0 .734.734 0 0 1 0 1.037h0l-.002.002-2.064 2.083H11v-1.056z",
      style: {"stroke-opacity":".4"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.76 4.642a6.666 6.666 0 0 0-12.423 3.14L1.333 8l.004.216a6.667 6.667 0 0 0 7.996 6.316v-1.865c0-.178.071-.348.198-.473l2.279-2.26a2.07 2.07 0 0 1 2.637-.236 6.67 6.67 0 0 0-.687-5.055m-6.203-.475a.667.667 0 0 1 1.105.42l.005.078v3.057l1.805 1.805.055.063a.67.67 0 0 1 0 .817l-.055.063-.063.055a.67.67 0 0 1-.818 0l-.062-.054-2-2-.058-.067a.67.67 0 0 1-.131-.318l-.006-.087V4.665l.004-.078a.67.67 0 0 1 .22-.42",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }